import { render, staticRenderFns } from "./basket-form-delivery-courier.vue?vue&type=template&id=3c116cf6"
import script from "./basket-form-delivery-courier.vue?vue&type=script&lang=js"
export * from "./basket-form-delivery-courier.vue?vue&type=script&lang=js"
import style0 from "./basket-form-delivery-courier.vue?vue&type=style&index=0&id=3c116cf6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VCol,VListItemContent,VListItemSubtitle,VListItemTitle,VRow,VTextField})
